import { Object3D, Scene } from "three";
import type { Engine } from "./Engine";
import type { CameraInterface } from "./CameraTypes";
import { trackStateRoot, untrackStateRoot } from "../history/SugarObject";

export const $engineKey = Symbol("engine");

let getActiveEngine: () => Engine | undefined = () => undefined;

export function setActiveEngineResolver(resolver: () => Engine | undefined) {
  getActiveEngine = resolver;
}

export class Entity extends Object3D {
  private [$engineKey]: Engine | null;
  protected _enabled: boolean = true;
  protected _initialized: boolean = false;

  constructor() {
    super();
    this[$engineKey] = getActiveEngine() ?? null;
  }

  get enabled() {
    return this._enabled;
  }

  set enabled(value) {
    if (this._enabled != value)
      if (value) this.onEnabled();
      else this.onDisabled();

    this._enabled = value;
  }

  get initialized() {
    return this._initialized;
  }

  set initialized(value: boolean) {
    this._initialized = value;
  }

  begin() {}

  onAdd(_engine: Engine) {
    trackStateRoot(this);
  }

  
  onRemove(_engine: Engine) {}
  onEnabled() {}
  onDisabled() {}

  beforeAnimate() {}

  animate(_dt: number, _scene?: Scene, _camera?: CameraInterface) {}

  beforeRender() {}

  end() {}

  dispose() {
    untrackStateRoot(this);
    this.engine?.removeEntity(this);
  }

  get engine(): Engine | null {
    return this[$engineKey] as Engine;
  }
}
